import type { Block, Page, SiteStatus } from '@/types/database';

// Mirrors the public_read_published RLS predicate in
// supabase/migrations/20260714160000_content_visibility.sql exactly — this
// is the client-side simulation of "what would an anonymous visitor see",
// needed because /studio/preview reads through the *authenticated* query
// path (which sees every page/block regardless of visibility) rather than
// hitting the anon RLS path a second time.
export function isEffectivelyPublic(
  page: Pick<Page, 'is_published' | 'visibility'>,
  block: Pick<Block, 'visibility'> | null,
  siteStatus: SiteStatus
): boolean {
  if (siteStatus !== 'published' || !page.is_published || page.visibility !== 'public') return false;
  return block ? block.visibility === 'public' : true;
}
